/* istanbul ignore file */
import React from 'react';
import { Breadcrumbs, ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { useExpenseUrl } from 'domain/shared/expense';

const ExpenseBreadcrumbs = ({ children }: { children: React.ReactNode }) => {
  const { getListUrl } = useExpenseUrl();

  return (
    <Breadcrumbs>
      <ListBreadcrumbItem entity="Worker Expenses" link={getListUrl()} />
      {children}
    </Breadcrumbs>
  );
};

export default ExpenseBreadcrumbs;
